
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/client-success",
      function () {
        return require("private-next-pages/destinations/client-success.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/client-success"])
      });
    }
  